module.exports = __webpack_public_path__ + "media/images/logo-bd200581a9351098ed0fdc9ab221d709.png";